import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CarrerasService } from 'src/app/services/carreras.service';
import { GruposService } from 'src/app/services/grupos.service';
import { environment } from '../../../environments/environment';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { PaquetesService } from 'src/app/services/paquetes.service';
import { ClientesService } from 'src/app/services/clientes.service';

@Component({
  selector: 'app-detalle-grupo',
  templateUrl: './detalle-grupo.component.html',
  styleUrls: ['./detalle-grupo.component.scss']
})
export class DetalleGrupoComponent implements OnInit {
  enviroment = environment.BASE_URL;

  grupoId;
  data;
  datosGrupo;
  formularioEdit;
  sesion_tematicaid;
  estatusid;
  institucionSelected;
  carreraSelected;
  instituciones;
  fondos;
  sesiones;
  estolas;
  estatus;

  fecha_entrega;
  fecha_graduacion;
  fecha_foto = '';

  respuestaDatosGrupo:any;
  respuestaInstituciones:any;
  respuestaEstolas:any;
  respuestaFondos:any;
  respuestaSesionesTematicas:any;
  respuestaUpdateGrupo:any;
  respuestaEstatusGrupo:any;
  respuestaCarreras:any;
  carreras;

  pago_tres = null;
  pago_uno  = null;
  pago_dos = null;
  error = '';

  categorias;
  respuestaPaquetes:any;
  vendedores:any;
  categoriasSeleccionadas:any = [];
  categoriasExistentes:any = [];

  seccion = 1;
  fiestas:any;
  fiestaId:any;

  fiestasGrupo:any;
  viajes:any;
  viajesGrupo:any;

  constructor(private actRoute: ActivatedRoute,  private _getDatosGrupo: GruposService, private modalService: NgbModal,
    private _getInstituciones: CarrerasService, private _getEstolas: GruposService,
    private _getSesionesTematicas: GruposService, private _getFondos: GruposService,
    private _updateGrupo: GruposService, private _getEstatusGrupos: GruposService,
    private _getCarreras: CarrerasService, private iziToast:Ng2IzitoastService,
    private _get: ClientesService,
    private el: ElementRef,
    private _getPaquetes: PaquetesService) { }

  ngOnInit(): void {
    
    
      this.formularioEdit = {
        nombre: '',
        carrera: '',
        imagen:'',
        fecha_graduacion: '',
        fecha_foto: '',
        fecha_entrega: '',
        lugar_entrega: '',
        generacion: '',
        fondo: '',
        sesion_tematica: '',
        fecha_pago_tres:'',
        fecha_pago_dos:'',
        fecha_pago_uno:'',
        categoria:'',
        vendedor:'',
        link_drive:'',
        forma_pago: 0,
        estatus_grupo: '',
        institucion: '',
        estola:'',
        fiesta:'',
        viaje:'',
        fiesta_adulto: '',
        fiesta_nino: '',
        numero_maximo_lugares: 0, 
      }

      this.getInstituciones();
      this.getEstolas();
      this.getSesionesTematicas();
      this.getFondos();
      this.getEstatusGrupos();
      this.getCarreras();
      this.getCategorias();
      this.getVendedores();
      this.getFiestas();
      this.getViajes();

      this.actRoute.paramMap.subscribe(params => {
        this.grupoId = this.actRoute.snapshot.paramMap.get('grupo');
          if ( this.grupoId){
            this.actualizarGrupo(this.grupoId);
            // this.getAnotaciones(this.clienteId);
          }
        });

      this.getFiestaGrupo();
      this.getViajesGrupo();
      
  }

  getFiestas(){
    this._get.getFiestas().subscribe(
      data => {
        this.respuestaPaquetes = data;
        if(this.respuestaPaquetes.success){
          this.fiestas = this.respuestaPaquetes.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  } 

  getViajes(){
    this._get.getViajes().subscribe(
      data => {
        this.respuestaPaquetes = data;
        if(this.respuestaPaquetes.success){
          this.viajes = this.respuestaPaquetes.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getFiestaGrupo(){
    this.data = {
      'grupo': this.grupoId
    }

    this._updateGrupo.getFiestaGrupo(this.data).subscribe(
      data => {
        this.respuestaPaquetes = data;
        if(this.respuestaPaquetes.success){
          this.fiestasGrupo = this.respuestaPaquetes.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  eliminarViajeGrupo(viaje){
    this.data = {
      'grupo': this.grupoId,
      'viaje': viaje
    }
    this._updateGrupo.eliminarViajeGrupo(this.data).subscribe(
      data => {
        this.respuestaPaquetes = data;
        if(this.respuestaPaquetes.success){
          this.iziToast.show(
            {
                title: 'Se ha eliminado el viaje correctamente, recargando...',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
            this.getViajesGrupo();
        }else {
          alert('No se cargaron los datos');
          this.error  = this.respuestaUpdateGrupo.error;
        }
      }, error => console.error(error));
  }

  getViajesGrupo(){
    this.data = {
      'grupo': this.grupoId
    }

    this._updateGrupo.getViajesGrupo(this.data).subscribe(
      data => {
        this.respuestaPaquetes = data;
        if(this.respuestaPaquetes.success){
          this.viajesGrupo = this.respuestaPaquetes.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  agregarViajeGrupo(){
    this.data = {
      'grupo': this.grupoId,
      'viaje': this.formularioEdit.viaje,
      'numero_maximo_lugares': this.formularioEdit.numero_maximo_lugares
    }

    this._updateGrupo.agregarViajeGrupo(this.data).subscribe(
      data => {
        this.respuestaPaquetes = data;
        if(this.respuestaPaquetes.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado el viaje correctamente, recargando...',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
            this.getViajesGrupo();
        }else {
          alert('No se cargaron los datos');
          this.error  = this.respuestaUpdateGrupo.error;
        }
      }, error => console.error(error));
  }
  
  changeSeccion(seccion){
    this.seccion = seccion;

    if(this.seccion == 1){
      const myElement = this.el.nativeElement.querySelector('#generales');
      myElement.classList.add('fondoAmarillo');

      const myElement2 = this.el.nativeElement.querySelector('#fotografia');
      myElement2.classList.remove('fondoAmarillo');
      
      const myElement3 = this.el.nativeElement.querySelector('#fiestas');
      myElement3.classList.remove('fondoAmarillo');

      const myElement4 = this.el.nativeElement.querySelector('#configuracion');
      myElement4.classList.remove('fondoAmarillo');

    }

    if(this.seccion == 2){
      const myElement = this.el.nativeElement.querySelector('#fotografia');
      myElement.classList.add('fondoAmarillo');

      const myElement2 = this.el.nativeElement.querySelector('#generales');
      myElement2.classList.remove('fondoAmarillo');

      const myElement3 = this.el.nativeElement.querySelector('#fiestas');
      myElement3.classList.remove('fondoAmarillo');

      const myElement4 = this.el.nativeElement.querySelector('#configuracion');
      myElement4.classList.remove('fondoAmarillo');

    }

    if(this.seccion == 3){
      const myElement = this.el.nativeElement.querySelector('#fiestas');
      myElement.classList.add('fondoAmarillo');

      const myElement2 = this.el.nativeElement.querySelector('#generales');
      myElement2.classList.remove('fondoAmarillo');

      const myElement3 = this.el.nativeElement.querySelector('#fotografia');
      myElement3.classList.remove('fondoAmarillo');

      const myElement4 = this.el.nativeElement.querySelector('#configuracion');
      myElement4.classList.remove('fondoAmarillo');
    }

    if(this.seccion == 4){
      const myElement = this.el.nativeElement.querySelector('#configuracion');
      myElement.classList.add('fondoAmarillo');

      const myElement2 = this.el.nativeElement.querySelector('#fiestas');
      myElement2.classList.remove('fondoAmarillo');

      const myElement3 = this.el.nativeElement.querySelector('#generales');
      myElement3.classList.remove('fondoAmarillo');

      const myElement4 = this.el.nativeElement.querySelector('#fotografia');
      myElement4.classList.remove('fondoAmarillo');
    }
  }

  getVendedores(){
    this._getSesionesTematicas.getVendedores().subscribe(
      data => {
        this.respuestaPaquetes = data;
        if(this.respuestaPaquetes.success){
          this.vendedores = this.respuestaPaquetes.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getCategorias(){
    this._getPaquetes.getCategorias().subscribe(
      data => {
        this.respuestaPaquetes = data;
        if(this.respuestaPaquetes.success){
          this.categorias = this.respuestaPaquetes.content;
          for(var i = 0; i< this.categorias.length; i++){
            this.categorias[i].checked = false;
          }
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getInstituciones(){
    this._getInstituciones.getInstituciones().subscribe(
      data => {
        this.respuestaInstituciones = data;
        if(this.respuestaInstituciones.success){
          this.instituciones = this.respuestaInstituciones.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
    
  }

  getEstolas(){
    this._getEstolas.getEstolas().subscribe(
      data => {
        this.respuestaEstolas = data;
        if(this.respuestaEstolas.success){
          this.estolas = this.respuestaEstolas.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getCarreras(){
    this._getCarreras.getCarreras().subscribe(
      data => {
        this.respuestaCarreras = data;
        if(this.respuestaCarreras.success){
          this.carreras = this.respuestaCarreras.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getSesionesTematicas(){
    this._getSesionesTematicas.getSesionesTematicas().subscribe(
      data => {
        this.respuestaSesionesTematicas = data;
        if(this.respuestaSesionesTematicas.success){
          this.sesiones = this.respuestaSesionesTematicas.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getFondos(){
    this._getFondos.getFondos().subscribe(
      data => {
        this.respuestaFondos = data;
        if(this.respuestaFondos.success){
          this.fondos = this.respuestaFondos.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getEstatusGrupos(){
    this._getEstatusGrupos.getEstatusGrupo().subscribe(
      data => {
        this.respuestaEstatusGrupo = data;
        if(this.respuestaEstatusGrupo.success){
          this.estatus = this.respuestaEstatusGrupo.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  actualizarGrupo(grupo){

    this.data = {
      'grupo':grupo
    }

    this._getDatosGrupo.getDatosGrupo(this.data).subscribe(
      data => {
        this.formularioEdit.forma_pago = 0;
        this.respuestaDatosGrupo = data;
        if(this.respuestaDatosGrupo.success){
          this.datosGrupo = this.respuestaDatosGrupo.content;
          this.formularioEdit.nombre_grupo = this.datosGrupo.nombre;
          // this.formularioEdit.fecha_graduacion = this.datosGrupo.fecha_graduacion;
          this.formularioEdit.fecha_foto = this.datosGrupo.fecha_foto;
          if (this.formularioEdit.fecha_foto != null){
            var anio_pago1 = this.formularioEdit.fecha_foto.split('-')[0];
            var mes_pago1 = this.formularioEdit.fecha_foto.split('-')[1];
            var dia_pago1 = this.formularioEdit.fecha_foto.split('-')[2];

            anio_pago1 = parseInt(anio_pago1, 10);
            mes_pago1 = parseInt(mes_pago1, 10);
            dia_pago1 = parseInt(dia_pago1, 10);

            this.formularioEdit.fecha_foto =  {year: anio_pago1, month: mes_pago1, day: dia_pago1};
          }

          // this.formularioEdit.fecha_entrega = this.datosGrupo.fecha_entrega;
          this.formularioEdit.lugar_entrega = this.datosGrupo.lugar_entrega;

          this.formularioEdit.hora_foto = this.datosGrupo.hora_toma_foto;
          this.formularioEdit.lugar_foto = this.datosGrupo.lugar_toma_foto;
          this.formularioEdit.link_whatsapp = this.datosGrupo.link_whatsapp;
          this.formularioEdit.promociones = this.datosGrupo.promociones;
          this.formularioEdit.categoria = this.datosGrupo.categoria;
          this.formularioEdit.numero_personas = this.datosGrupo.numero_personas;
          this.formularioEdit.link_drive = this.datosGrupo.link_drive;
          

          if(this.datosGrupo.forma_pago != null){
            this.formularioEdit.forma_pago = this.datosGrupo.forma_pago;
          }

          this.formularioEdit.fecha_pago_uno = this.datosGrupo.fecha_pago_uno;
          if (this.formularioEdit.fecha_pago_uno != null){
            var anio_pago1 = this.formularioEdit.fecha_pago_uno.split('-')[0];
            var mes_pago1 = this.formularioEdit.fecha_pago_uno.split('-')[1];
            var dia_pago1 = this.formularioEdit.fecha_pago_uno.split('-')[2];

            anio_pago1 = parseInt(anio_pago1, 10);
            mes_pago1 = parseInt(mes_pago1, 10);
            dia_pago1 = parseInt(dia_pago1, 10);

            this.formularioEdit.fecha_pago_uno =  {year: anio_pago1, month: mes_pago1, day: dia_pago1};
          }

          this.formularioEdit.fecha_pago_dos = this.datosGrupo.fecha_pago_dos;
          if (this.formularioEdit.fecha_pago_dos != null){
            var anio_pago2 = this.formularioEdit.fecha_pago_dos.split('-')[0];
            var mes_pago2 = this.formularioEdit.fecha_pago_dos.split('-')[1];
            var dia_pago2 = this.formularioEdit.fecha_pago_dos.split('-')[2];

            anio_pago2 = parseInt(anio_pago2, 10);
            mes_pago2 = parseInt(mes_pago2, 10);
            dia_pago2 = parseInt(dia_pago2, 10);

            this.formularioEdit.fecha_pago_dos =  {year: anio_pago2, month: mes_pago2, day: dia_pago2};
          }


          this.formularioEdit.fecha_pago_tres = this.datosGrupo.fecha_pago_tres;
          if (this.formularioEdit.fecha_pago_tres != null){
            var anio_pago3 = this.formularioEdit.fecha_pago_tres.split('-')[0];
            var mes_pago3 = this.formularioEdit.fecha_pago_tres.split('-')[1];
            var dia_pago3 = this.formularioEdit.fecha_pago_tres.split('-')[2];

            anio_pago3 = parseInt(anio_pago3, 10);
            mes_pago3 = parseInt(mes_pago3, 10);
            dia_pago3 = parseInt(dia_pago3, 10);

            this.formularioEdit.fecha_pago_tres =  {year: anio_pago3, month: mes_pago3, day: dia_pago3};
          }
          

          this.formularioEdit.fecha_graduacion = this.datosGrupo.fecha_graduacion;
          if (this.formularioEdit.fecha_graduacion != null){
            var anio_fecha_graduacion3 = this.formularioEdit.fecha_graduacion.split('-')[0];
            var mes_fecha_graduacion3 = this.formularioEdit.fecha_graduacion.split('-')[1];
            var dia_fecha_graduacion33 = this.formularioEdit.fecha_graduacion.split('-')[2];

            anio_fecha_graduacion3 = parseInt(anio_fecha_graduacion3, 10);
            mes_fecha_graduacion3 = parseInt(mes_fecha_graduacion3, 10);
            dia_fecha_graduacion33 = parseInt(dia_fecha_graduacion33, 10);

            this.formularioEdit.fecha_graduacion =  {year: anio_fecha_graduacion3, month: mes_fecha_graduacion3, day: dia_fecha_graduacion33};
          }

          this.formularioEdit.fecha_entrega = this.datosGrupo.fecha_entrega;
          if (this.formularioEdit.fecha_entrega != null){
            var anio_fecha_entrega = this.formularioEdit.fecha_entrega.split('-')[0];
            var mes_fecha_entrega = this.formularioEdit.fecha_entrega.split('-')[1];
            var dia_fecha_entrega = this.formularioEdit.fecha_entrega.split('-')[2];

            anio_fecha_entrega = parseInt(anio_fecha_entrega, 10);
            mes_fecha_entrega = parseInt(mes_fecha_entrega, 10);
            dia_fecha_entrega = parseInt(dia_fecha_entrega, 10);

            this.formularioEdit.fecha_entrega =  {year: anio_fecha_entrega, month: mes_fecha_entrega, day: dia_fecha_entrega};
          }

          
                    
          if (this.formularioEdit.hora_foto != null){
            var hora = this.formularioEdit.hora_foto.split(':')[0];
            var minutos = this.formularioEdit.hora_foto.split(':')[1];
            hora = parseInt(hora, 10);
            minutos = parseInt(minutos, 10);
            this.formularioEdit.hora_foto =  {hour: hora, minute: minutos};
          }else{
            this.formularioEdit.hora_foto =  {hour: 0, minute: 0};
          }
          
          

          this.formularioEdit.generacion = this.datosGrupo.generacion;
          
          this.formularioEdit.fondo = this.datosGrupo.fondo;

          this.formularioEdit.sesion_tematica = this.datosGrupo.sesion_tematica;
          this.formularioEdit.estola = this.datosGrupo.estola;
          this.formularioEdit.vendedor = this.datosGrupo.vendedor;
          
          this.sesion_tematicaid = this.datosGrupo.sesion_tematicaid;
          this.formularioEdit.sesion_tematica = this.datosGrupo.sesion_tematicaid;

          this.formularioEdit.estatus_grupo = this.datosGrupo.estatus_grupoid;
          this.estatusid = this.datosGrupo.estatus_grupoid;

          this.formularioEdit.institucion = this.datosGrupo.escuelaid;
          this.institucionSelected = this.datosGrupo.escuelaid;

          this.carreraSelected = this.datosGrupo.carreraid;
          this.formularioEdit.carrera = this.datosGrupo.carreraid;

          this.categoriasExistentes = this.datosGrupo.categorias;
          this.grupoId = this.datosGrupo.id;

          this.checkCategoriasExistentes();
          // document.getElementById('click3').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  imageChange2(files: FileList){
    this.formularioEdit.imagen2 = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formularioEdit.imagen2.type.toString() == 'image/png' ||
        this.formularioEdit.imagen2.type.toString() == 'image/jpeg' ) {
        if (this.formularioEdit.imagen2.size > 10485760) {
          this.formularioEdit.imagen2 = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formularioEdit.imagen2);
    } else {
      this.formularioEdit.imagen2 = null;
      $('#imagen').focus();
      return;
    }
  }

  imageChange(files: FileList){
    this.formularioEdit.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formularioEdit.imagen.type.toString() == 'image/png' ||
        this.formularioEdit.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formularioEdit.imagen.size > 10485760) {
          this.formularioEdit.imagen = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formularioEdit.imagen);
    } else {
      this.formularioEdit.imagen = null;
      $('#imagen').focus();
      return;
    }
  }

  updateGrupo(grupo){
    this.pago_uno = '';
    this.pago_dos = '';
    this.pago_tres = '';
    this.fecha_entrega = '';
    this.fecha_graduacion = '';
    const formData = new FormData();

    if (this.formularioEdit.fecha_pago_tres != null){
      this.pago_tres = this.formularioEdit.fecha_pago_tres['year']+'-'+this.formularioEdit.fecha_pago_tres['month']+'-'+this.formularioEdit.fecha_pago_tres['day']
    }

    if (this.formularioEdit.fecha_pago_uno != null){
      this.pago_uno = this.formularioEdit.fecha_pago_uno['year']+'-'+this.formularioEdit.fecha_pago_uno['month']+'-'+this.formularioEdit.fecha_pago_uno['day'];
    }

    if (this.formularioEdit.fecha_pago_dos != null){
      this.pago_dos = this.formularioEdit.fecha_pago_dos['year']+'-'+this.formularioEdit.fecha_pago_dos['month']+'-'+this.formularioEdit.fecha_pago_dos['day'];
    }

    if (this.formularioEdit.fecha_graduacion != null){
      this.fecha_graduacion = this.formularioEdit.fecha_graduacion['year']+'-'+this.formularioEdit.fecha_graduacion['month']+'-'+this.formularioEdit.fecha_graduacion['day']
    }

    if (this.formularioEdit.fecha_entrega != null){
      this.fecha_entrega = this.formularioEdit.fecha_entrega['year']+'-'+this.formularioEdit.fecha_entrega['month']+'-'+this.formularioEdit.fecha_entrega['day'];
    }

    if (this.formularioEdit.fecha_foto != null && this.formularioEdit.fecha_foto != ''){
      this.fecha_foto = this.formularioEdit.fecha_foto['year']+'-'+this.formularioEdit.fecha_foto['month']+'-'+this.formularioEdit.fecha_foto['day'];
    }


    if (this.formularioEdit.imagen){ 
      formData.append('escudo', this.formularioEdit.imagen);
    }

    if (this.formularioEdit.imagen2){ 
      formData.append('escudo2', this.formularioEdit.imagen2);
    }

    formData.append('grupo', grupo);
    formData.append('estola', this.formularioEdit.estola);
    formData.append('fondo', this.formularioEdit.fondo);
    formData.append('institucion', this.formularioEdit.institucion);
    formData.append('carrera', this.formularioEdit.carrera);
    formData.append('estatus_grupo', this.formularioEdit.estatus_grupo);
    formData.append('sesion_tematica', this.formularioEdit.sesion_tematica);
    formData.append('nombre_grupo', this.formularioEdit.nombre_grupo);
    formData.append('generacion', this.formularioEdit.generacion);
    formData.append('fecha_graduacion', this.fecha_graduacion);
    formData.append('fecha_foto', this.fecha_foto);
    formData.append('fecha_entrega', this.fecha_entrega);
    formData.append('lugar_entrega', this.formularioEdit.lugar_entrega);
    formData.append('hora_toma_foto', this.formularioEdit.hora_foto['hour']+':'+this.formularioEdit.hora_foto['minute']);
    formData.append('lugar_toma_foto', this.formularioEdit.lugar_foto);
    formData.append('link_whatsapp', this.formularioEdit.link_whatsapp);
    formData.append('numero_personas', this.formularioEdit.numero_personas);
    formData.append('promociones', this.formularioEdit.promociones);
    formData.append('forma_pago', this.formularioEdit.forma_pago);
    formData.append('vendedor', this.formularioEdit.vendedor);
    formData.append('categoria', this.formularioEdit.categoria);
    formData.append('categorias', this.categoriasSeleccionadas);
    formData.append('link_drive', this.formularioEdit.link_drive);
    formData.append('fecha_pago_uno', this.pago_uno);
    formData.append('fecha_pago_dos', this.pago_dos);
    formData.append('fecha_pago_tres', this.pago_tres);
    
    this._updateGrupo.updateGrupo(formData).subscribe(
      data => {
        this.respuestaUpdateGrupo = data;
        if(this.respuestaUpdateGrupo.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado el grupo correctamente, recargando...',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
            setTimeout(function(){
              // window.location.href='grupos';
              this.error = ''
              window.location.reload();
           }, 5000);
        }else {
          alert('No se cargaron los datos');
          this.error  = this.respuestaUpdateGrupo.error;
        }
      }, error => console.error(error));

  }
  
  seleccionarCategoria(categoria:number, event:any){
    if (event.target.checked) {
      this.categoriasSeleccionadas.push(categoria);
    }else{

      for(var i = 0; i<this.categoriasSeleccionadas.length; i++){
        if(this.categoriasSeleccionadas[i] == categoria){
          this.categoriasSeleccionadas.splice(i, 1);
        } 
      }
    }

    console.log(this.categoriasSeleccionadas);
  }

  checkCategoriasExistentes(){
    for(var i = 0; i<this.categoriasExistentes.length; i++){
      this.categoriasSeleccionadas.push(this.categoriasExistentes[i].id);

      for(var j = 0; j < this.categorias.length; j++){
          if(this.categoriasExistentes[i].id == this.categorias[j].id){
            this.categorias[j].checked = true;
          }
      }
    }

    console.log(this.categoriasSeleccionadas);
  }

  agregarFiestaGrupo(){
    this.data = {
      'grupo': this.grupoId,
      'fiesta': this.formularioEdit.fiesta,
      'maximo_boletos_adultos': this.formularioEdit.fiesta_adulto,
      'maximo_boletos_nino': this.formularioEdit.fiesta_nino,
    }

    this._updateGrupo.agregarFiestaGrupo(this.data).subscribe(
      data => {
        this.respuestaUpdateGrupo = data;
          if(this.respuestaUpdateGrupo.success){
            this.iziToast.show(
              {
                  title: 'Se ha actualizado el grupo correctamente, recargando...',
                  titleColor: '#f8f8ff',
                  color: '#4CAF50',
                  position: 'topRight',
                  closeOnEscape: true,
              });
              this.getFiestaGrupo();
            }else {
            alert('No se cargaron los datos');
            this.error  = this.respuestaUpdateGrupo.error;
          }
    }, error => console.error(error));
  }

  eliminarFiestaGrupo(fiesta){
    this.data = {
      'grupo': this.grupoId,
      'fiesta':  fiesta,
    }

    this._updateGrupo.eliminarFiestaGrupo(this.data).subscribe(
      data => {
        this.respuestaUpdateGrupo = data;
          if(this.respuestaUpdateGrupo.success){
            this.iziToast.show(
              {
                  title: 'Se ha actualizado el grupo correctamente, recargando...',
                  titleColor: '#f8f8ff',
                  color: '#4CAF50',
                  position: 'topRight',
                  closeOnEscape: true,
              });
              this.getFiestaGrupo();

          }else {
            alert('No se cargaron los datos');
            this.error  = this.respuestaUpdateGrupo.error;
          }
    }, error => console.error(error));
  }
 
  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
